import { css } from '@emotion/core'

import { BorderRadius } from '../../../enums/borderRadius'
import { DefaultValue } from '../../../enums/defaultValue'
import { StyledComponent } from '../../../types/styledComponent'
import { getDefaultTransition } from '../../../utils/getDefaultTransition'
import { InputWrapperProps } from '../types/inputWrapperProps'
import { getAlignmentStyle } from './getAlignmentStyle'
import { getAppearanceStyle } from './getAppearanceStyle'
import { getDisabledStyle } from './getDisabledStyle'
import { getErrorStyle } from './getErrorStyle'
import { getFocusStyle } from './getFocusStyle'
import { getFontStyle } from './getFontStyle'
import { getHoverStyle } from './getHoverStyle'
import { getPlaceholderStyle } from './getPlaceholderStyle'
import { getSizeStyle } from './getSizeStyle'
import { getTruncateStyle } from './getTruncateStyle'

const hasDisabledStyle = ({ disabled }: InputWrapperProps) => disabled
const hasErrorStyle = ({ disabled, error }: InputWrapperProps) => !disabled && error
const hasHoverStyle = ({ bordered, disabled, error, focused }: InputWrapperProps) =>
  bordered && !disabled && !error && !focused
const hasFocusStyle = ({ bordered, disabled, focused }: InputWrapperProps) => bordered && !disabled && focused
const hasTruncateStyle = ({ truncate }: InputWrapperProps) => truncate

export const getInputWrapperStyle = (props: InputWrapperProps, Input?: StyledComponent, isTextArea = false) => {
  const InputComponent: StyledComponent | undefined = isTextArea ? undefined : Input

  return css`
    display: ${props.hidden ? 'none' : 'flex'};
    width: 100%;
    border-radius: ${props.isRounded ? BorderRadius.RFull : DefaultValue.BorderRadius};
    align-items: stretch;
    cursor: ${props.selectLook ? 'default' : 'text'};
    ${getDefaultTransition('border', 'background')};

    ${getAppearanceStyle(props)};
    ${getSizeStyle(props.size)};
    ${getAlignmentStyle(props.alignment, InputComponent)}
    ${getFontStyle(props.weight, props.selectLook, InputComponent)};
    ${getPlaceholderStyle(props.theme, props.selectLook, InputComponent)};
    ${hasDisabledStyle(props) && getDisabledStyle(props.bordered, InputComponent)};
    ${hasErrorStyle(props) && getErrorStyle()};
    ${hasHoverStyle(props) && getHoverStyle()};
    ${hasFocusStyle(props) && getFocusStyle(props.error)};
    ${hasTruncateStyle(props) && getTruncateStyle(InputComponent)};
  `
}
